module.exports = __webpack_public_path__ + "img/jueewo_animation_n25_4b.ad3d8e02.gif";